import { render, staticRenderFns } from "./pageLast.vue?vue&type=template&id=68a2b54a&scoped=true&"
import script from "./pageLast.vue?vue&type=script&lang=js&"
export * from "./pageLast.vue?vue&type=script&lang=js&"
import style0 from "./pageLast.vue?vue&type=style&index=0&id=68a2b54a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a2b54a",
  null
  
)

export default component.exports